/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/


export const YoutubeSettingsDtoPrivacyStatusEnum = {
    private: "private",
    unlisted: "unlisted",
    public: "public"
} as const;

export type YoutubeSettingsDtoPrivacyStatusEnumKey = (typeof YoutubeSettingsDtoPrivacyStatusEnum)[keyof typeof YoutubeSettingsDtoPrivacyStatusEnum];

export type YoutubeSettingsDto = {
    /**
     * @type string
    */
    language?: string | null;
    /**
     * @description Privacy status for the video. \"private\" acts as a draft (default)
     * @default "private"
     * @type string
    */
    privacyStatus?: YoutubeSettingsDtoPrivacyStatusEnumKey | null;
    /**
     * @description Indicates whether the video is designated as child-directed content
     * @type boolean
    */
    madeForKids?: boolean | null;
    /**
     * @description YouTube video category ID
     * @type string
    */
    categoryId?: string | null;
};